var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretDown = function SvgCaretDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 5,
    fill: "none",
    viewBox: "0 0 9 5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.5 4.967a.7.7 0 0 1-.25-.042.6.6 0 0 1-.217-.142L.967 1.717a.63.63 0 0 1-.184-.467q0-.283.184-.467A.63.63 0 0 1 1.433.6q.284 0 .467.183l2.6 2.6 2.6-2.6A.63.63 0 0 1 7.567.6q.283 0 .466.183a.63.63 0 0 1 .184.467.63.63 0 0 1-.184.467L4.967 4.783a.6.6 0 0 1-.217.142.7.7 0 0 1-.25.042"
  })));
};
export default SvgCaretDown;